'use strict';

document.addEventListener('DOMContentLoaded', () => {
    let $routePlanner = document.querySelector('.RoutePlanner');

    if (!$routePlanner) {
        return;
    }

    let now = new Date();

    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    now.setSeconds(0);
    now.setMilliseconds(0);

    document.getElementById('f-timetable-time').valueAsDate = now;
    document.getElementById('f-timetable-date').valueAsDate = now;

    document.getElementById('f-timetable-date').addEventListener('input', (event) => {
        let date = event.target.valueAsDate,
            dd = date.getDate().toString().padStart(2, '0'),
            mm = (date.getMonth() + 1).toString().padStart(2, '0'),
            yy = date.getFullYear().toString().slice(-2);

        event.target.closest('form').querySelector('[name="date"]').value = dd + '.' + mm + '.' + yy;
    });
    document.getElementById('f-timetable-date').dispatchEvent(new Event('input', {bubbles: true}));

    document.querySelectorAll('.js-suggestions').forEach(($element) => {
        new autoComplete({
            selector: '#' + $element.id,
            data: {
                src: async (query) => {
                    try {
                        const source = await fetch(`?routeplanner/suggestions`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({term: query, type: $element.dataset.type}),
                        });

                        return await source.json();
                    } catch (error) {
                        return error;
                    }
                },
                keys: ['label'],
                cache: false,
                filter: function() {
                    let results = [];

                    this.store.forEach((item) => {
                        results.push({
                            key: 'label',
                            match: item.label,
                            value: item,
                        });
                    });

                    return results;
                },
            },
            resultsList: {
                element: (list, data) => {
                    if (!data.results.length) {
                        const message = document.createElement('div');

                        message.setAttribute('class', 'no-result');

                        list.prepend(message);
                    }
                },
                maxResults: undefined,
                noResults: true,
            },
            resultItem: {
                highlight: true,
                element: (item, data) => {
                    item.classList.add('type--' + (data.value.type === 1 ? 'location' : 'stop'));
                },
            },
            debounce: 250,
            searchEngine: 'loose',
            threshold: 1,
        });

        $element.addEventListener('selection', (event) => {
            $element.closest('form').querySelector('[name="' + $element.dataset.shadow + '"]').value = event.detail.selection.value.id;
            $element.value = event.detail.selection.value.rawValue;
        });

        if ($element.dataset.start) {
            $element.addEventListener('change', () => {
                $element.closest('form').querySelector('[name="start"]').disabled = $element.value === '';
            });
        }
    });
});
